import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { useQuery } from "@tanstack/react-query";

interface Params {
  authToken: string;
  tipoRelatorio: string;
  idEmpreendimento: string;
  idEquipe: string;
}

interface FetchParams extends Params {
  enabled?: boolean;
}

/**
 * Função para listar responsáveis da revenda (fetch).
 *
 * @param {params} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.tipoRelatorio - Tipo de relatório, "R", "V", "U" ou "G".
 * @param {string} params.idEmpreendimento - ID do empreendimento.
 * @param {string} params.idEquipe - ID da equipe.
 * @param {boolean} params.enabled - Indica se a query deve ser executada.
 * @returns {Promise<any>} - Resposta da API.
 */
export function fetchListarResponsaveisRevenda(params: FetchParams): any {
  const fetch = async (): Promise<any> => {
    const url = "/api/autonomo/ListarAutonomoResponsaveisRevenda";
    const { authToken, ...parameters } = params;
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    };
    const response = await instanceConexao.post(url, parameters, config);
    return response?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-listar-responsaveis-revenda"],
    enabled: params?.enabled ?? false,
    refetchOnWindowFocus: false,
  });

  return query;
}

/**
 * Função para listar responsáveis da revenda.
 *
 * @param {params} params - Parâmetros para listagem.
 * @param {string} params.authToken - Token de autenticação do usuário.
 * @param {string} params.tipoRelatorio - Tipo de relatório, "R", "V", "U" ou "G".
 * @param {string} params.idEmpreendimento - ID do empreendimento.
 * @param {string} params.idEquipe - ID da equipe.
 * @returns {Promise<any>} - Resposta da API.
 */
export const postListarResponsaveisRevenda = async (params: {
  authToken: string;
  tipoRelatorio: string;
  idEmpreendimento: string;
  idEquipe: string;
}): Promise<any> => {
  const url = "/api/autonomo/ListarAutonomoResponsaveisRevenda";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.post(url, parameters, config);
  return response?.data;
};
